import React, {Component } from 'react';
import Formulario from './NotaDebitoPlanillaForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class NotaDebitoPlanilla extends Component {
    state = {
        crear: true,
        documento: null,
        periodo: '',
        pais: '',
        id_pais: '',
    }

    componentDidMount = () => {
        const { match, leer, getModulo, 
            leerPeriodoD } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let cuenta = ruta.split('/');
        leerPeriodoD(cuenta[5], cuenta[7]);
        getModulo(cuenta[5], cuenta[4]);
    }

    setArchivo = (documento) => {
        this.setState({documento});
    };

    setPeriodo = (periodo) => {
        this.setState({periodo});
    };

    setPais = (pais) => {
        this.setState({pais});
    };

    setIDPais = (id_pais) => {
        this.setState({id_pais});
    };
    
    registroNotaDebito = (data) => {
        const { registroNotaDebito } = this.props;
        registroNotaDebito( {...data, documento: null},
            [{ "file": this.state.documento, "name": 'archivo' }],
            this.state.periodo,
            this.state.pais,
            this.state.id_pais
        )
    }

    render(){
        const { 
            lectura, listarDistribuidor, listarTiposGasto, agregarLinea, 
            detalleDocN, detalleND, eliminarLinea, eliminarLineaNota,
            loader, modulo, periodoD, agregarNuevaLinea,
            modificarNotaDebito, buscarCuenta, cuentaContable, gastos
        } = this.props;
        const { crear } = this.state;
        return(
            <React.Fragment>
                <LoadMask loading={loader} dark>
                    <Formulario
                        crear = {crear}
                        modulo = {modulo}
                        periodoD={periodoD}
                        lectura = {lectura}
                        listarDistribuidor = {listarDistribuidor}
                        listarTiposGasto = {listarTiposGasto}
                        agregarLinea = {agregarLinea}
                        detalleDocN = {detalleDocN}
                        registroNotaDebito = {this.registroNotaDebito}
                        detalleND = {detalleND}
                        eliminarDocumento = {eliminarLinea}
                        eliminarLineaNota = {eliminarLineaNota}
                        agregarNuevaLinea = {agregarNuevaLinea}
                        modificarNotaDebito = {modificarNotaDebito}
                        buscarCuenta = {buscarCuenta}
                        cuentaContable = {cuentaContable}
                        gastos = {gastos}
                        setArchivo = {this.setArchivo}
                        setPeriodo = {this.setPeriodo}
                        setPais = {this.setPais}
                        setIDPais = {this.setIDPais}
                    />
                </LoadMask>
            </React.Fragment>
        )
    }

}
export default NotaDebitoPlanilla;
